// eslint-disable-next-line import/prefer-default-export
export const TIME_AND_DISTANCE_SOURCE_DICT = {
  ESTIMATED: 'estimated',
  DEFINED: 'defined',
  FALLBACK: 'fallback',
};
